import { hasLicense } from "@sourcewhale/shared/src/assets/js/src/general/licenses";
import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
import { mount, unmount } from "svelte";
import LicenseRequired from "../elements/Modularization/LicenseRequired.svelte";
import Marketing from "../pages/Marketing/Marketing.svelte";

const routeMountTarget = {
  "/search": "search-builder-wrapper",
  "/search-results": "search-results-wrapper",
};

const bindModularization = ({ targetId = "wrapper", licenses = [] }) => {
  const target = document.getElementById(targetId);
  return mount(LicenseRequired, {
    target,
    props: {
      licenses,
    },
  });
};

const bindMarketingPage = (wrapperId) => {
  const target = document.getElementById(wrapperId);
  return mount(Marketing, { target });
};

export const conditionallyBindModularization = ({
  licensesRequired,
  altCondition,
  success,
  contentWrapperId = "content-wrapper",
  bindLockWrapperOnFailure = true,
}) => {
  userStore.once();
  const el = document.querySelector(`#${contentWrapperId}`);
  let initialStyle = "";
  let doneSuccess = false;
  let licenseRequiredComponent = null;
  let marketingComponent = null;

  userStore.subscribe((user) => {
    if (
      licensesRequired
        .map((kind) => hasLicense(user, kind, true))
        .find(Boolean) ||
      altCondition?.(user)
    ) {
      if (!doneSuccess) {
        if (initialStyle) el.style = initialStyle;
        success();
        doneSuccess = true;
      }
      if (licenseRequiredComponent) {
        unmount(licenseRequiredComponent);
      }
      if (marketingComponent) {
        unmount(marketingComponent);
      }
      return;
    }

    if (!bindLockWrapperOnFailure) return;

    if (!licenseRequiredComponent && !marketingComponent) {
      const wrapperTargetId = routeMountTarget[window.location.pathname];
      if (wrapperTargetId) {
        marketingComponent = bindMarketingPage(wrapperTargetId);
        return;
      }
      initialStyle = el.style;
      el.style = "display: none !important";
      licenseRequiredComponent = bindModularization({
        licenses: licensesRequired,
      });
    }
  });
};
